<template>
  <v-container class="mx-8 ma-sm-12" fluid>
    <div class="text-h5 font-weight-black _light_grey--text">{{ $t('chatService') }}</div>
    <v-card class="my-4 my-sm-12 mx-auto pa-10 _light_grey" height="580">
      <v-card class="_light_grey" height="450">
        <div class="scroll-card" ref="cardContent">
          <template v-for="(item, index) in message">
            <Chat :data="item" :key="index"/>
          </template>
        </div>
      </v-card>
      <v-text-field class="my-4 transparent" outlined v-model="question" :label="$t('sendChat')" append-icon="mdi-arrow-up-bold-circle-outline" @click:append="sendMsg()" @keydown="handleKeydown"></v-text-field>
    </v-card>
    <v-row justify="end">
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn color="_blue" exact-pathicon v-bind="attrs" v-on="on" @click="changePageHandler('customerService')">
            <v-icon large color="_light_grey">mdi-face-agent</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('customerService') }}</span>
      </v-tooltip>
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from 'vuex';
import axios from 'axios';
import Db from '@/api/awsDb';
import Chat from '../components/Chat.vue';

export default {
  name: 'ChatService',
  data: () => ({
    question: '',
    message: [],
    chatUser: {},
  }),
  components: { Chat },
  created() {
    // console.log(this.chatUuid);
    Db.read('chatService', 'id', this.chatUuid).then((res) => {
      const temp = {
        name: this.$t('imacloud') + this.$t('chatService'),
        avatarPath: this.imacloudPath,
        text: '請問有什麼需要幫忙的嗎？',
        time: new Date().getTime(),
        color: '_deep_blue',
      };
      this.message = res === undefined ? [temp] : res.chat;
      this.scrollToBottom();
    });
  },
  computed: {
    ...mapState('authenticate', ['userAttribute', 'chatUuid']),
    avatarPath() {
      if (!Object.prototype.hasOwnProperty.call(this.userAttribute, 'avatar')) return '';
      return `${process.env.VUE_APP_S3_URL}public/avatar/${this.userAttribute.avatar.path}`;
    },
    imacloudPath() {
      return `${process.env.VUE_APP_S3_URL}appstore/favicon.ico`;
    },
  },
  methods: {
    async sendMsg() {
      if (this.question === '') return;
      const chatUser = {
        name: this.userAttribute.name,
        avatarPath: this.avatarPath,
        text: this.question,
        time: new Date().getTime(),
        color: '_blue',
      };
      this.message.push(chatUser);
      try {
        this.$store.commit('loading/start', { text: 'working' });
        let res = null;
        // const userEmail = this.userAttribute.email;
        // if (!userEmail) {
        //   res = await axios({ url: `https://www.customer-ervice-robot.com/apps/${this.chatUuid}/debug`, method: 'POST', data: { query: this.question } });
        // } else {
        res = await axios({ url: `https://www.customer-ervice-robot.com/apps/${this.chatUuid}/member`, method: 'POST', data: { query: this.question } });
        // }
        console.log(res.data.data);
        // const res = await axios({ url: 'https://kimt1uwwca.execute-api.ap-northeast-1.amazonaws.com/Prod/test', method: 'POST', data: { chatUuid: this.chatUuid, question: this.question } });
        if (res.data.code === 'fail') {
          this.$store.commit('loading/stop');
          this.$store.commit('notify/set', { type: 'alarm', msg: [res.data.message] });
          return;
        }
        const chatAi = {
          name: this.$t('imacloud') + this.$t('chatService'),
          avatarPath: this.imacloudPath,
          text: res.data.data.content,
          time: new Date().getTime(),
          color: '_deep_blue',
        };
        this.message.push(chatAi);
        const saveMsg = {
          id: this.chatUuid.toString(),
          email: this.userAttribute.email,
          chat: this.message,
          updateTime: new Date().getTime(),
        };
        const ret = await Db.create('chatService', saveMsg);
        console.log(ret);
        this.$store.commit('loading/stop');
        this.question = '';
      } catch (error) {
        this.$store.commit('loading/stop');
        this.$store.commit('notify/set', { type: 'alarm', msg: [error] });
      }
      this.scrollToBottom();
    },
    handleKeydown(event) {
      if (event.key === 'Enter') {
        this.sendMsg();
      }
    },
    scrollToBottom() {
      this.$nextTick(() => {
        const content = this.$refs.cardContent;
        content.scrollTop = content.scrollHeight;
      });
    },
    changePageHandler(pageName, params = {}) {
      this.$router.push({ name: pageName, params });
    },
  },
};
</script>

<style>
.scroll-card {
  overflow-y: auto;
  max-height: 400px;
}
</style>
